
import { mapState, mapGetters } from 'vuex';
import uiMixin from '@/mixins/uiMixin';

const PRODUCT_ITEM_ID_PREFIX = 'product/';
const AUTHOR_ITEM_ID_PREFIX = 'author/';

export default {
  mixins: [uiMixin],

  data() {
    return {
      search: null,
      loading: false,
      categoryIcons: {
        'Apps Manager': '/../img/icons/Apps-Manager.png',
        'After Effects': '/../img/icons/After Effects-24.png',
        'Premiere Pro': '/../img/icons/Premiere-24.png',
        Photoshop: '/../img/icons/Photoshop-24.png',
        Illustrator: '/../img/icons/Illustrator-24.png',
      },
    };
  },

  watch: {
    searchInput(newValue) {
      this.search = newValue;
    },
  },

  methods: {
    categoriesIcon(product) {
      return product.productCategory.map(
        (category) => this.categoryIcons[category] || null
      );
    },
    averageReview(author, isProduct = false) {
      const reviews = isProduct
        ? author.reviews
        : author.products.flatMap((product) => product.reviews);
      const totalReviews = reviews.length;
      const totalRating = reviews.reduce(
        (acc, review) => acc + review.rating,
        0
      );
      return totalReviews > 0 ? totalRating / totalReviews : 0;
    },
    totalReviews(author, isProduct = false) {
      const reviews = isProduct
        ? author.reviews
        : author.products.flatMap((product) => product.reviews);
      return reviews.length;
    },
    onItemSelected(composedId) {
      if (composedId) {
        if (composedId.startsWith(PRODUCT_ITEM_ID_PREFIX)) {
          const productId = composedId.substring(PRODUCT_ITEM_ID_PREFIX.length);
          const product = this.getProductById(productId);

          if (product && product.permalink) {
            const productRoute = `/apps/${product.permalink}`;
            this.$router.push(productRoute);
          } else {
            console.error('Product information is missing or invalid');
          }
        } else if (composedId.startsWith(AUTHOR_ITEM_ID_PREFIX)) {
          const authorId = composedId.substring(AUTHOR_ITEM_ID_PREFIX.length);

          const author = this.getAuthorById(authorId);
          if (author && author.userName) {
            const authorRoute = `/authors/${author.userName}`;
            this.$router.push(authorRoute);
          } else {
            console.error('Author information is missing or invalid');
          }
        }
      }
    },
  },
  computed: {
    ...mapState({
      authors: (state) => state.products.authors,
      products: (state) => state.products.list,
    }),
    ...mapGetters('products', ['getProductById', 'getAuthorById']),

    filteredItems() {
      const searchTerm = (this.search || '').toLowerCase();
      const filteredProducts = this.products.filter((product) =>
        product.productName.toLowerCase().includes(searchTerm)
      );
      const filteredAuthors = this.authors.filter((author) =>
        author.name.toLowerCase().includes(searchTerm)
      );

      const items = [];

      if (filteredProducts.length || filteredAuthors.length) {
        items.push({ header: 'Products' });
        if (filteredProducts.length) {
          items.push(
            ...filteredProducts.map((product) => ({
              ...product,
              id: PRODUCT_ITEM_ID_PREFIX + product.id,
              type: PRODUCT_ITEM_ID_PREFIX,
              name: product.productName,
            }))
          );
        }

        if (filteredProducts.length && filteredAuthors.length) {
          items.push({ divider: true });
        }

        items.push({ header: 'Authors' });
        if (filteredAuthors.length) {
          items.push(
            ...filteredAuthors.map((author) => ({
              ...author,
              id: AUTHOR_ITEM_ID_PREFIX + author.id,
              type: AUTHOR_ITEM_ID_PREFIX,
              name: author.name,
            }))
          );
        }
      }

      return items;
    },
  },
};
